import { Component, Input, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent {
  @ViewChild('calendarOnlyTime') calendarOnlyTime: Calendar;

  @Input() label: string = 'Selecione uma data';

  @Input() form: FormGroup;

  @Input() controlName: string;

  @Input() calendarType: 'noTime' | 'hasTime' | 'onlyTime' = 'noTime';

  @Input() today: any;

  @Input() maxDate: any;

  get getToday() {
    let today = new Date()
    let todayFormatted = new Date(today)
    return todayFormatted
  }

  get control() {
    return this.form.get(this.controlName) as FormControl;
  }

  onDateSelect(value: any): void {
    const formattedDateControl = moment(value).format("MM/DD/YYYY");
    this.form.get(this.controlName)?.setValue(formattedDateControl);
  }
  
  setTime() {
    let selectedTime = this.control.value;
    if (!selectedTime) {
      selectedTime = new Date();
    }
    const selectedTimeFormatted = moment(selectedTime).format(
      'HH:mm:ss',
   )
    this.form.get(this.controlName)?.setValue(selectedTimeFormatted);
    console.log(selectedTimeFormatted)
    this.calendarOnlyTime.overlayVisible = false;
  }

  get isRequiredInvalid(): boolean {
    return this.control && this.control.errors && this.control.errors['required'] && this.control.touched;
  }

}
